import AxiosManager from "../_axiosManager";

interface ICaseAdd {
  title: string;
  category: string;
  beforeImgSrc: string;
  afterImgSrc: string;
  imageIds: number[];
}

export async function getCases(id: string) {
  const res = await AxiosManager.getInstance().get(
    `/admin/manage/service-case/${id}`,
  );

  return res;
}

export async function postCases(params: ICaseAdd) {
  const res = await AxiosManager.getInstance().post(
    "/admin/manage/service-case",
    params,
  );

  return res;
}

export async function putCases(caseId: string, params: ICaseAdd) {
  const res = await AxiosManager.getInstance().put(
    `/admin/manage/service-case/${caseId}`,
    params,
  );

  return res;
}

export async function delCases(caseId: string) {
  const res = await AxiosManager.getInstance().delete(
    `/admin/manage/service-case/${caseId}`,
  );

  return res;
}
